import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { getUserMics, initAgoraHandler } from '../slice/voiceCallSlice';
import { PopupError } from './errors/popupError';
import { TopError } from './errors/topError';
import { GroupScreen } from './group/groupScreen';
import { Sidebar } from './sidebar/sidebar';
import { WebsocketProvider } from './websocketProvider';

export const App: React.FC = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(initAgoraHandler());
        dispatch(getUserMics());
    }, [dispatch]);

    return (
        <WebsocketProvider>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                <TopError />
                <PopupError />
                <div style={{ display: 'flex', height: '100%' }}>
                    <Sidebar width={251} />
                    <GroupScreen />
                </div>
            </div>
        </WebsocketProvider>
    );
};
